import { companySections } from './company-sections.js';
import { documentationModules } from './system-documentation-content.js';
import { documentationPageHelp, type DocumentationPageKey } from './system-documentation-flows.js';

export function pageDocumentation(page: DocumentationPageKey) {
  const target = documentationPageHelp[page];
  const path =
    page === 'new-sale'
      ? '/companies/:key/sales/new'
      : page === 'client'
        ? '/companies/:key/clients/:clientId'
        : page === 'package'
          ? '/companies/:key/packages/:packageId'
          : page === 'closing'
            ? '/companies/:key/scheduling/appointments/:appointmentId/closing'
            : companySections
                .find((section) => section.key === page)
                ?.to.replace('$companyKey', ':key');
  return (
    documentationModules.flatMap((area) => area.pages).find((entry) => entry.path === path) ??
    documentationModules.flatMap((area) => area.pages).find((entry) => entry.name === target.name)
  );
}
